import React from "react";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

// 加工指示セクションの操作エリア(サマリ帯・一括入力・グループ操作・モード切替)の描画をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createHinbanSectionActionRenderer(deps) {
    const {
        DicVal,
        KAKOUSIJI_DETAIL_COPY_MODE,
        KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
        KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE,
        KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE,
        KAKOUSIJI_QUALITY_BASE_PANEL_TYPE,
        KAKOUSIJI_SAMPLE_GROUP_KEY,
        KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE,
        KAKOUSIJI_UI_ACTION,
        activeKakousijiKey,
        entrylock,
        getKnownKakousijiGroupNos,
        getKnownKakousijiGroupNosByPanelType,
        handleKakousijiGroupAdd,
        handleKakousijiGroupCopy,
        isEmpty,
        isKakousijiDemandNouhinPanel,
        kakouType,
        kakouTypeButtons,
        kakousijiBulkInputMap,
        kakousijiGroupNoToLabel,
        kakousijiOrderDateMap,
        kakousijiOrderHistoryData,
        kakousijiOrderDenpyoMap,
        setKakousijiOrderDenpyoMap,
        formid,
        kakousijiSummaryList,
        kakousijiSummaryLoading,
        normalizeKakousijiGroupNo,
        normalizeKakousijiText,
        openKakousijiAddDialog,
        openKakousijiGroupDialog,
        openTemporaryOrderTab,
        resolveKakousijiColorOptionsForDialog,
        resolveKakousijiGroupCopySelection,
        resolveKakousijiGroupSelection,
        resolveKakousijiNouhinDateBand,
        runAfterActiveInputCommit,
        runKakousijiDetailAction,
        runKakousijiHeaderAction,
        setKakouType,
        setKakousijiBulkInputMap,
        setKakousijiGroupControlState,
        setKakousijiQualityGroupControlState,
        setKakousijiOrderDateMap,
        switchActiveKakousijiKey
    } = deps;

    function renderKakousijiSummaryBand() {
        const summaryItems = [...kakousijiSummaryList].sort((a, b) => {
            const aSample = !!DicVal(a, 'isSample', false);
            const bSample = !!DicVal(b, 'isSample', false);
            if (aSample === bSample) return 0;
            return aSample ? 1 : -1;
        });
        return (
            <Paper className="hinban-summary-paper">
                <div className="hinban-summary-head">
                    <span className="hinban-summary-title">加工指示 -</span>
                    <Button
                        type="button"
                        variant="outlined"
                        size="small"
                        onClick={openKakousijiAddDialog}
                        disabled={kakousijiSummaryLoading}
                    >
                        加工指示追加
                    </Button>
                </div>
                <div className="hinban-summary-band">
                    <div className="hinban-summary-cards">
                        {summaryItems.map((item, index) => {
                            const selected = item.key === activeKakousijiKey;
                            const value = isEmpty(item.summaryValue) ? '未設定' : item.summaryValue;
                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => runAfterActiveInputCommit(() => switchActiveKakousijiKey(item.key))}
                                    className={selected ? 'hinban-summary-card hinban-summary-card--selected' : 'hinban-summary-card'}
                                    style={{ borderRight: index === summaryItems.length - 1 ? '1px solid #cfd5e6' : '0' }}
                                >
                                    <div className="hinban-summary-card-line">{'区分  ' + item.kubunLabel}</div>
                                    <div className="hinban-summary-card-line">{String(DicVal(item, 'key', '')).trim() === KAKOUSIJI_SAMPLE_GROUP_KEY ? item.summaryLabel + value : item.summaryLabel + '  ' + value}</div>
                                    {!isEmpty(item.supplierName) && item.summaryLabel !== '仕入先' ? <div className="hinban-summary-card-supplier">{item.supplierName}</div> : null}
                                </button>
                            );
                        })}
                        {kakousijiSummaryLoading ? <div className="hinban-summary-loading">加工指示を読み込み中です...</div> : null}
                    </div>
                </div>

            </Paper>
        );
    }
    // ================= 発注履歴(加工指示入力と同じ制御) =================
    // 履歴あり: リストボックスに「発注日 [伝票番号]」が並び、履歴表示ボタンで
    //           該当の発注入力画面を別タブ表示する。
    // 履歴なし: 「履歴なし」の空リストボックスのみ表示し、履歴表示ボタンは出さない。
    function buildKakousijiOrderHistoryOptionRows(history) {
        return (Array.isArray(history) ? history : [])
            .map((row, index) => {
                const date = String(DicVal(row, 'date', '') ?? '').trim();
                const denpyoNo = String(DicVal(row, 'denpyoNo', '') ?? '').trim();
                const value = denpyoNo !== '' ? denpyoNo : (date + '|' + index);
                const label = denpyoNo === '' ? date : (date + ' [' + denpyoNo + ']');
                return { value, label, date, denpyoNo, row };
            })
            .filter((item) => item.date !== '' || item.denpyoNo !== '');
    }
    function resolveKakousijiOrderHistoryFormTarget(historyId) {
        const id = String(historyId ?? '').trim();
        if (id === 'seihin') return { callid: 'ShnOrder', historyType: '' };
        if (id === 'sozai') return { callid: 'RawM?type=D_KHD', historyType: '0' };
        if (id === 'fuzoku') return { callid: 'RawM?type=D_KHD', historyType: '1' };
        if (id === 'fukushizai') return { callid: 'RawM?type=D_KHD', historyType: '2' };
        return null;
    }
    function openKakousijiHistorySlip(historyId, row) {
        if (isEmpty(row)) return;
        const denpyoNo = String(DicVal(row, 'denpyoNo', '') ?? '').trim();
        if (denpyoNo === '') return;
        const target = resolveKakousijiOrderHistoryFormTarget(historyId);
        if (isEmpty(target) || isEmpty(target.callid)) {
            fnc.current.warnmsg('履歴表示起動定義が見つかりません。');
            return;
        }
        const state = { status: 'ENTRY', code: denpyoNo, accepttype: formid };
        if (!isEmpty(target.historyType)) state.historyType = target.historyType;
        const openedTab = fnc.current.callform(state, target.callid);
        if (openedTab === null) {
            fnc.current.warnmsg('タブを開けませんでした。ブラウザのポップアップ設定を確認してください。');
        }
    }
    function renderKakousijiOrderHistoryCard(historyId, orderLabel, onOrderClick) {
        const history = Array.isArray(DicVal(kakousijiOrderHistoryData, historyId, null))
            ? DicVal(kakousijiOrderHistoryData, historyId, [])
            : [];
        const optionRows = buildKakousijiOrderHistoryOptionRows(history);
        const hasHistoryOptions = optionRows.length !== 0;
        const currentValue = String(DicVal(kakousijiOrderDenpyoMap, historyId, '') ?? '').trim();
        const nextValue = currentValue !== '' && optionRows.some((item) => item.value === currentValue)
            ? currentValue
            : DicVal(optionRows[0], 'value', '');
        const selected = optionRows.find((item) => item.value === nextValue) || null;
        return (
            <div className="kakousiji-order-history__card">
                <Button type="button" size="small" variant="contained" className="hinban-green-button hinban-green-button--w98" disabled={entrylock} onClick={onOrderClick}>
                    {orderLabel}
                </Button>
                <div className="kakousiji-order-history__date-wrap">
                    <select
                        value={nextValue}
                        onChange={(e) => {
                            const value = String(e.target.value ?? '').trim();
                            setKakousijiOrderDenpyoMap((prev) => ({ ...prev, [historyId]: value }));
                        }}
                        disabled={!hasHistoryOptions}
                        className="kakousiji-form-select"
                        title="発注履歴"
                    >
                        {hasHistoryOptions
                            ? optionRows.map((item) => (
                                <option key={historyId + '_' + item.value} value={item.value}>{item.label}</option>
                            ))
                            : <option value="">履歴なし</option>}
                    </select>
                </div>
                {hasHistoryOptions ? (
                    <Button
                        type="button"
                        size="small"
                        variant="contained"
                        className="kakousiji-button kakousiji-button--history"
                        disabled={isEmpty(selected)}
                        onClick={() => {
                            if (isEmpty(selected)) return;
                            openKakousijiHistorySlip(historyId, selected.row);
                        }}
                    >
                        履歴表示
                    </Button>
                ) : null}
            </div>
        );
    }
    function renderKakousijiSijisuActionArea() {
        return (
            <div className="hinban-order-card">
                {renderKakousijiOrderHistoryCard('seihin', '製商品発注', () => runKakousijiHeaderAction(KAKOUSIJI_UI_ACTION.PRODUCT_ORDER))}
            </div>
        );
    }
    function renderKakousijiActionButton(label, onClick, minWidth = 96) {
        return (
            <Button
                type='button'
                size='small'
                variant='contained'
                className="hinban-green-button"
                style={{ minWidth: minWidth }}
                disabled={entrylock}
                onClick={onClick}
            >
                {label}
            </Button>
        );
    }
    function renderKakousijiSimpleActionRow(buttons) {
        return (
            <div className="hinban-action-box">
                <div className="hinban-action-row hinban-action-row--gap8">
                    {buttons.map((button) => (
                        <React.Fragment key={button.label}>
                            {renderKakousijiActionButton(button.label, button.onClick, button.minWidth || 96)}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    }
    function renderKakousijiSozaiMeisaiActionArea() {
        const lossRate = DicVal(DicVal(kakousijiBulkInputMap, KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE, {}), 'lossRate', '');
        return (
            <div className="hinban-action-box">
                <div className="hinban-action-row">
                    {renderKakousijiOrderHistoryCard('sozai', '素材発注', openTemporaryOrderTab)}
                    <div className="hinban-action-right">
                        <input
                            value={lossRate}
                            onChange={(e) => setKakousijiBulkInputMap((prev) => ({
                                ...prev,
                                [KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE]: {
                                    ...DicVal(prev, KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE, {}),
                                    lossRate: e.target.value
                                }
                            }))}
                            className="hinban-action-input"
                        />
                        <Button
                            type="button"
                            size="small"
                            variant="contained"
                            className="hinban-green-button"
                            disabled={entrylock}
                            onClick={() => runKakousijiDetailAction(KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE, KAKOUSIJI_DETAIL_COPY_MODE.BULK_LOSS)}
                        >
                            ロス率一括設定
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
    function renderKakousijiFuzokuMeisaiActionArea() {
        const lossRate = DicVal(DicVal(kakousijiBulkInputMap, KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE, {}), 'lossRate', '');
        const shikyuKbn = DicVal(DicVal(kakousijiBulkInputMap, KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE, {}), 'shikyuKbn', '');
        return (
            <div className="hinban-action-box">
                <div className="hinban-action-row">
                    {renderKakousijiOrderHistoryCard('fuzoku', '附属発注', openTemporaryOrderTab)}
                    <div className="hinban-action-right">
                        <input
                            value={lossRate}
                            onChange={(e) => setKakousijiBulkInputMap((prev) => ({
                                ...prev,
                                [KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE]: {
                                    ...DicVal(prev, KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE, {}),
                                    lossRate: e.target.value
                                }
                            }))}
                            className="hinban-action-input"
                        />
                        <Button
                            type="button"
                            size="small"
                            variant="contained"
                            className="hinban-green-button"
                            disabled={entrylock}
                            onClick={() => runKakousijiDetailAction(KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE, KAKOUSIJI_DETAIL_COPY_MODE.BULK_LOSS)}
                        >
                            ロス率一括設定
                        </Button>
                        <input
                            value={shikyuKbn}
                            onChange={(e) => setKakousijiBulkInputMap((prev) => ({
                                ...prev,
                                [KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE]: {
                                    ...DicVal(prev, KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE, {}),
                                    shikyuKbn: e.target.value
                                }
                            }))}
                            className="hinban-action-input"
                        />
                        <Button
                            type="button"
                            size="small"
                            variant="contained"
                            className="hinban-green-button"
                            disabled={entrylock}
                            onClick={() => runKakousijiDetailAction(KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE, KAKOUSIJI_DETAIL_COPY_MODE.BULK_SHIKYU)}
                        >
                            支給区分一括設定
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
    // 加工指示画面(Kakousiji.js)の renderItemGroupTabBar と同じ構造で描画する。
    // アイテム=タブ、グループ=トグルボタン、選択グループの製品カラー表示、
    // 複写(副資材のみ)は加工指示画面の複写エリアと同じ見た目にする。
    // CSSは css/Kakousiji.css の kakousiji-itemgroup-tabbar / kakousiji-group-control を共用する。
    function renderKakousijiGroupControlArea(panelType) {
        const isFukushizai = panelType === KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE;
        const selection = isFukushizai
            ? resolveKakousijiGroupCopySelection(panelType)
            : resolveKakousijiGroupSelection();
        const itemOptions = selection.itemOptions;
        const selectedItem = selection.selectedItem;
        const groupOptions = selection.groupOptions;
        const selectedGroup = selection.selectedGroup;
        const sourceItem = normalizeKakousijiText(DicVal(selection, 'sourceItem', ''));
        const sourceGroupOptions = Array.isArray(DicVal(selection, 'sourceGroupOptions', null)) ? DicVal(selection, 'sourceGroupOptions', []) : [];
        const sourceGroup = normalizeKakousijiGroupNo(DicVal(selection, 'sourceGroup', ''));
        // 選択中グループに紐づく製品カラー(チェック済みのみ)。
        const selectedGroupColors = (typeof resolveKakousijiColorOptionsForDialog === 'function' && selectedItem !== '' && selectedGroup !== '')
            ? resolveKakousijiColorOptionsForDialog(panelType, selectedItem, selectedGroup).filter((option) => !!option.checked)
            : [];
        // アイテム切替(旧プルダウン onChange と同じ状態更新)。
        const handleItemSelect = (nextItemRaw) => {
            const nextItem = normalizeKakousijiText(nextItemRaw);
            if (!isFukushizai) {
                // 品質表示スコープは独立した選択stateを更新する
                const nextQualityGroups = getKnownKakousijiGroupNos(nextItem);
                setKakousijiQualityGroupControlState((prev) => ({ ...prev, itemCd: nextItem, groupNo: DicVal(nextQualityGroups, 0, '') }));
                return;
            }
            const nextGroups = isFukushizai
                ? getKnownKakousijiGroupNosByPanelType(panelType, nextItem)
                : getKnownKakousijiGroupNos(nextItem);
            setKakousijiGroupControlState((prev) => ({
                ...prev,
                itemCd: nextItem,
                groupNo: DicVal(nextGroups, 0, ''),
                sourceItemCd: isFukushizai ? nextItem : prev.sourceItemCd,
                sourceGroupNo: isFukushizai
                    ? DicVal(getKnownKakousijiGroupNosByPanelType(panelType, nextItem), 0, '')
                    : prev.sourceGroupNo
            }));
        };
        return (
            <div className="kakousiji-itemgroup-tabbar hinban-itemgroup-tabbar">
                <div className="kakousiji-itemgroup-tabbar__row kakousiji-itemgroup-tabbar__row--items">
                    <span className="kakousiji-itemgroup-tabbar__label">アイテム</span>
                    <div className="kakousiji-itemgroup-tabbar__items" role="tablist">
                        {itemOptions.map((item) => {
                            const code = normalizeKakousijiText(DicVal(item, 'code', ''));
                            const active = code === selectedItem;
                            return (
                                <button
                                    key={'kakousiji-item-tab-' + panelType + '-' + code}
                                    type="button"
                                    role="tab"
                                    aria-selected={active}
                                    className={'kakousiji-itemgroup-tabbar__tab' + (active ? ' kakousiji-itemgroup-tabbar__tab--active' : '')}
                                    disabled={entrylock}
                                    onClick={() => { if (!active) handleItemSelect(code); }}
                                >
                                    {DicVal(item, 'label', code)}
                                </button>
                            );
                        })}
                    </div>
                </div>
                <div className="kakousiji-itemgroup-tabbar__row kakousiji-itemgroup-tabbar__row--groups">
                    <span className="kakousiji-itemgroup-tabbar__label">グループ</span>
                    <div className="kakousiji-itemgroup-tabbar__groups">
                        {groupOptions.map((groupNo) => {
                            const normalized = normalizeKakousijiGroupNo(groupNo);
                            const active = normalized === selectedGroup;
                            return (
                                <button
                                    key={'kakousiji-group-toggle-' + panelType + '-' + normalized}
                                    type="button"
                                    aria-pressed={active}
                                    className={'kakousiji-itemgroup-tabbar__toggle' + (active ? ' kakousiji-itemgroup-tabbar__toggle--active' : '')}
                                    disabled={entrylock}
                                    onClick={() => {
                                        if (active) return;
                                        if (isFukushizai) {
                                            setKakousijiGroupControlState((prev) => ({ ...prev, groupNo: normalized }));
                                        } else {
                                            setKakousijiQualityGroupControlState((prev) => ({ ...prev, groupNo: normalized }));
                                        }
                                    }}
                                >
                                    {kakousijiGroupNoToLabel(normalized)}
                                </button>
                            );
                        })}
                    </div>
                    <IconButton type='button' size='small' className="kakousiji-group-control__icon-button" title='グループ追加' disabled={entrylock} onClick={() => handleKakousijiGroupAdd(panelType, selectedItem)}><Icon className="kakousiji-group-control__icon">add</Icon></IconButton>
                    <IconButton type='button' size='small' className="kakousiji-group-control__icon-button" title='ケアラベル削除' disabled={entrylock || selectedItem === '' || selectedGroup === ''} onClick={() => runAfterActiveInputCommit(() => openKakousijiGroupDialog(panelType, 'delete', selectedItem, selectedGroup))}><Icon className="kakousiji-group-control__icon">remove</Icon></IconButton>
                    <IconButton type='button' size='small' className="kakousiji-group-control__icon-button" title='グループ編集' disabled={entrylock || selectedItem === '' || selectedGroup === ''} onClick={() => runAfterActiveInputCommit(() => openKakousijiGroupDialog(panelType, 'edit', selectedItem, selectedGroup))}><Icon className="kakousiji-group-control__icon">edit</Icon></IconButton>
                </div>
                <div className="kakousiji-itemgroup-tabbar__row kakousiji-itemgroup-tabbar__row--colors">
                    <span className="kakousiji-itemgroup-tabbar__label">製品カラー</span>
                    <div className="kakousiji-itemgroup-tabbar__colors">
                        {selectedGroupColors.length === 0
                            ? <span className="kakousiji-itemgroup-tabbar__color-empty">-</span>
                            : selectedGroupColors.map((option) => (
                                <span key={'kakousiji-group-color-' + panelType + '-' + option.colorCd} className="kakousiji-itemgroup-tabbar__color">
                                    {option.colorCd + (normalizeKakousijiText(option.colorName) === '' ? '' : ':' + option.colorName)}
                                </span>
                            ))}
                    </div>
                </div>
            </div>
        );
    }
    // 複写UI(副資材のみ)。加工指示画面と同じくセクション内のアクションバーとして描画する。
    function renderKakousijiCopyControlArea(panelType) {
        if (panelType !== KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE) return null;
        const selection = resolveKakousijiGroupCopySelection(panelType);
        const itemOptions = selection.itemOptions;
        const selectedItem = selection.selectedItem;
        const selectedGroup = selection.selectedGroup;
        const sourceItem = normalizeKakousijiText(DicVal(selection, 'sourceItem', ''));
        const sourceGroupOptions = Array.isArray(DicVal(selection, 'sourceGroupOptions', null)) ? DicVal(selection, 'sourceGroupOptions', []) : [];
        const sourceGroup = normalizeKakousijiGroupNo(DicVal(selection, 'sourceGroup', ''));
        return (
            <div className="kakousiji-action-bar">
                <div className="kakousiji-group-control">
                    <span className="kakousiji-group-control__copy-label">複写元アイテム</span>
                    <select
                        value={sourceItem}
                        onChange={(e) => {
                            const nextItem = normalizeKakousijiText(e.target.value);
                            const nextGroups = getKnownKakousijiGroupNosByPanelType(panelType, nextItem);
                            setKakousijiGroupControlState((prev) => ({
                                ...prev,
                                sourceItemCd: nextItem,
                                sourceGroupNo: DicVal(nextGroups, 0, '')
                            }));
                        }}
                        className="kakousiji-group-control__select"
                        disabled={entrylock}
                    >
                        {itemOptions.map((item) => <option key={'kakousiji-copy-item-' + item.code} value={item.code}>{item.label}</option>)}
                    </select>
                    <span className="kakousiji-group-control__copy-label">複写元グループ</span>
                    <select
                        value={sourceGroup}
                        onChange={(e) => setKakousijiGroupControlState((prev) => ({ ...prev, sourceGroupNo: normalizeKakousijiGroupNo(e.target.value) }))}
                        className="kakousiji-group-control__select kakousiji-group-control__select--group"
                        disabled={entrylock}
                    >
                        {sourceGroupOptions.map((groupNo) => <option key={'kakousiji-copy-group-no-' + groupNo} value={groupNo}>{kakousijiGroupNoToLabel(groupNo)}</option>)}
                    </select>
                    <Button
                        type='button'
                        size='small'
                        variant='contained'
                        className="kakousiji-button kakousiji-button--copy"
                        disabled={entrylock || selectedItem === '' || selectedGroup === '' || sourceItem === '' || sourceGroup === ''}
                        onClick={() => runAfterActiveInputCommit(() => handleKakousijiGroupCopy(panelType, selectedItem, selectedGroup, sourceItem, sourceGroup))}
                    >
                        複写
                    </Button>
                </div>
            </div>
        );
    }
    // スコープ枠の先頭に置くタブバー(アイテム/グループ/製品カラー)。
    function renderKakousijiFukushizaiTabBarArea() {
        return renderKakousijiGroupControlArea(KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE);
    }
    function renderKakousijiQualityTabBarArea() {
        return renderKakousijiGroupControlArea(KAKOUSIJI_QUALITY_BASE_PANEL_TYPE);
    }
    // 副資材セクション内のアクション領域は複写UIのみ(タブバーはスコープ枠先頭へ移動)。
    function renderKakousijiFukushizaiBaseActionArea() {
        return renderKakousijiCopyControlArea(KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE);
    }
    // 品質表示セクション内のアクション領域は無し(タブバーはスコープ枠先頭へ移動)。
    function renderKakousijiQualityBaseActionArea() {
        return null;
    }
    function renderKakousijiSoseiActionArea(panelInfo, inline = false) {
        const button = (
            <Button
                type='button'
                size='small'
                variant='contained'
                className={inline ? 'hinban-green-button hinban-green-button--sosei hinban-green-button--inline' : 'hinban-green-button hinban-green-button--sosei'}
                disabled={entrylock}
                onClick={() => runKakousijiHeaderAction(KAKOUSIJI_UI_ACTION.CALC, String(DicVal(panelInfo, 'type', '')).trim())}
            >
                {'計算'}
            </Button>
        );
        if (inline) return button;
        return (
            <div className="hinban-action-box">
                <div className="hinban-action-row hinban-action-row--end">
                    {button}
                </div>
            </div>
        );
    }
    function renderKakousijiFukushizaiListActionArea() {
        const lossRate = DicVal(DicVal(kakousijiBulkInputMap, KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE, {}), 'lossRate', '');
        const shikyuKbn = DicVal(DicVal(kakousijiBulkInputMap, KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE, {}), 'shikyuKbn', '');
        // 加工指示入力と同じ配置: 左=発注履歴+一覧反映、右寄せ=ロス率/支給区分の一括設定
        return (
            <div className="hinban-action-box">
                <div className="hinban-action-row">
                    {renderKakousijiOrderHistoryCard('fukushizai', '副資材発注', openTemporaryOrderTab)}
                    <Button type="button" size="small" variant="contained" className="hinban-green-button" disabled={entrylock} onMouseDown={(e) => { e.preventDefault(); runAfterActiveInputCommit(() => runKakousijiDetailAction(KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE, KAKOUSIJI_DETAIL_COPY_MODE.LIST_REFLECT)); }}>一覧反映</Button>
                    <div className="hinban-action-right">
                        <input value={lossRate} onChange={(e) => setKakousijiBulkInputMap((prev) => ({ ...prev, [KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE]: { ...DicVal(prev, KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE, {}), lossRate: e.target.value } }))} className="hinban-action-input" />
                        <Button type="button" size="small" variant="contained" className="hinban-green-button" disabled={entrylock} onClick={() => runKakousijiDetailAction(KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE, KAKOUSIJI_DETAIL_COPY_MODE.BULK_LOSS)}>ロス率一括設定</Button>
                        <input value={shikyuKbn} onChange={(e) => setKakousijiBulkInputMap((prev) => ({ ...prev, [KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE]: { ...DicVal(prev, KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE, {}), shikyuKbn: e.target.value } }))} className="hinban-action-input" />
                        <Button type="button" size="small" variant="contained" className="hinban-green-button" disabled={entrylock} onClick={() => runKakousijiDetailAction(KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE, KAKOUSIJI_DETAIL_COPY_MODE.BULK_SHIKYU)}>支給区分一括設定</Button>
                    </div>
                </div>
            </div>
        );
    }
    function renderKakousijiModeButtons() {
        return (
            <div className="hinban-mode-switch">
                {kakouTypeButtons.map((btn) => (
                    <button
                        key={btn.id}
                        type="button"
                        className={kakouType === btn.id ? 'hinban-mode-button hinban-mode-button--active' : 'hinban-mode-button'}
                        onClick={() => setKakouType(btn.id)}
                    >
                        {btn.label}
                    </button>
                ))}
            </div>
        );
    }
    function renderKakousijiNouhinDateBand(panelInfo) {
        if (!isKakousijiDemandNouhinPanel(panelInfo)) return null;

        const dates = resolveKakousijiNouhinDateBand(panelInfo);
        const items = [
            { key: 'color', label: '' },
            { key: 'size', label: '' },
            { key: 'toinyu', label: dates.toinyu },
            { key: 'siire', label: dates.siire },
            { key: 'nouhin', label: dates.nouhin },
            { key: 'center', label: dates.center },
            { key: 'part1', label: dates.part1 },
            { key: 'part2', label: dates.part2 },
            { key: 'part3', label: dates.part3 },
            { key: 'part4', label: dates.part4 },
            { key: 'zansu', label: dates.zansu }
        ];

        return (
            <div className="hinban-kakousiji-nouhin-dateband">
                {items.map((item) => (
                    <div key={item.key} className="hinban-kakousiji-nouhin-datecell">
                        {item.label}
                    </div>
                ))}
            </div>
        );
    }

    return {
        renderKakousijiSummaryBand,
        renderKakousijiSijisuActionArea,
        renderKakousijiActionButton,
        renderKakousijiSimpleActionRow,
        renderKakousijiSozaiMeisaiActionArea,
        renderKakousijiFuzokuMeisaiActionArea,
        renderKakousijiGroupControlArea,
        renderKakousijiFukushizaiBaseActionArea,
        renderKakousijiQualityBaseActionArea,
        renderKakousijiFukushizaiTabBarArea,
        renderKakousijiQualityTabBarArea,
        renderKakousijiSoseiActionArea,
        renderKakousijiFukushizaiListActionArea,
        renderKakousijiModeButtons,
        renderKakousijiNouhinDateBand
    };
}
